module.exports = __webpack_public_path__ + "assets/img/goodwe-inverters.6844041a.png";